import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchSite, fetchGallery, authMe } from "./api";

const Ctx = createContext(null);

export function SiteProvider({ children }) {
    const [site, setSite] = useState(null);
    const [gallery, setGallery] = useState([]);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshSite = useCallback(async () => {
        try {
            const [s, g] = await Promise.all([fetchSite(), fetchGallery()]);
            setSite(s);
            setGallery(g);
        } catch (e) {
            console.error("site load", e);
        }
    }, []);

    const refreshUser = useCallback(async () => {
        try {
            const me = await authMe();
            setUser(me);
        } catch (_) {
            setUser(null);
        }
    }, []);

    useEffect(() => {
        // Skip /me on OAuth callback
        const hasSession = typeof window !== "undefined" && window.location.hash?.includes("session_id=");
        (async () => {
            await refreshSite();
            if (!hasSession) await refreshUser();
            setLoading(false);
        })();
    }, [refreshSite, refreshUser]);

    // Update <title> when site loads
    useEffect(() => {
        if (site?.business_name) {
            document.title = `${site.business_name} | Lawn Care in North Alabama`;
        }
    }, [site]);

    return (
        <Ctx.Provider value={{ site, gallery, user, loading, refreshSite, refreshUser, setUser }}>
            {children}
        </Ctx.Provider>
    );
}

export function useSite() {
    const ctx = useContext(Ctx);
    if (!ctx) throw new Error("useSite must be inside SiteProvider");
    return ctx;
}
